// extracted by mini-css-extract-plugin
export default {"noData":"styles_noData__zjcVM","fetchingStatus":"styles_fetchingStatus__Bq70B"};